// The state machine for the app
// --
// Items in lowercase are the states, children in
// uppercase are the allowed actions.

const mapMachine = {
  consent: {
    AGREE: "addPoint"
  },
  addPoint: {
    // BACK: "browse",
    ADDED: "waitingForPointConfirmation"
  },
  waitingForPointConfirmation: {
    BACK: "addPoint",
    SUBMIT: "imageUpload"
  },
  imageUpload: {
    BACK: "waitingForPointConfirmation",
    UPLOAD_SUCCESS: "pointSaved",
    UPLOAD_FAILURE: "uploadFailed"
  }
};

export default mapMachine;



// WEBPACK FOOTER //
// ./source/js/MapMachine.js